// @ts-nocheck
import { t } from 'ttag'
import en from 'i18n/job_profile_skills.en.json'
import nb from 'i18n/job_profile_skills.nb.json'
import * as R from 'ramda'

const languages = { en, nb }

export const categoryNames = (language = 'en') =>
  R.pipe(
    R.prop(R.__, languages),
    R.map(R.props(['label', 'description', 'explanation', 'category'])),
  )(language)

export const variableNames = () => ({
  productivity: [
    t`high productivity`,
    t`Is high productivity an important goal for your organization? By prioritizing high productivity, the algorithm will adjust the evaluation of factors important for high productivity. For example, a candidate’s ability to work structured will be crucial.`,
  ],
  sicknessAbsence: [
    t`low sickness absence`,
    t`Does your organization have a goal to reduce sickness absence? By prioritizing low sickness absence, the algorithm will adjust the evaluation of factors important for low sickness absence.`,
  ],
  turnover: [
    t`low turnover`,
    t`Securing employees who stay in the workforce longer is important to many organizations. By prioritizing low turnover, the algorithm will adjust the evaluation of factors important for low turnover.`,
  ],
  // wage: [t`wage pressure`, t`will not ask for a high salary`],
})
